import React, { useState } from "react";
import { Col, Card, Row, Spin, Modal } from "antd";
import ButtonComp from "../../Components/ButtonComp/ButtonComp";
import {
  cancelCircle,
  messageQuestion,
} from "../../Utils/imports";
import { useDispatch, useSelector } from "react-redux";

const Support = () => {
  const { current } = useSelector((state) => state?.plant);
  const [modalOpen, setModalOpen] = useState(false);
  const handleModal = (open, id) => {
    setModalOpen(open);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const modalContent = (
    <div>
      <div>
        <h4>
          <strong>Site Champion Name</strong>{" "}
          <span style={{ marginLeft: "20%" }}>
            {current?.plant?.siteChampion?.name}
          </span>
        </h4>
        <h4>
          <strong>Site Champion Email</strong>{" "}
          <span style={{ marginLeft: "20%" }}>
            {current?.plant?.siteChampion?.email}
          </span>
        </h4>
        <h4>
          <strong>Ticket URL</strong>{" "}
          <span style={{ marginLeft: "33%" }}>
            <a>{current?.plant?.siteChampion?.url}</a>
          </span>
        </h4>
      </div>
      <h4 style={{ marginTop: "8%" }}>
        <strong>ESCALATION MATRIX</strong>
      </h4>
      <div style={{ display: "flex", gap: "0" }}>
        <Card
          className="support-card"
          style={{ flex: 1, border: "1px solid #CCCCCC", textAlign: "center" }}
        >
          <h4 style={{ color: "#1E6EFE" }}>
            <strong>LEVEL 1</strong>
          </h4>
          <p style={{ fontWeight: "bold" }}>LOCAL DSS IT SUPPORT</p>
        </Card>
        <Card
          className="support-card"
          style={{ flex: 1, border: "1px solid #CCCCCC", textAlign: "center" }}
        >
          <h4 style={{ color: "#1E6EFE" }}>
            <strong>LEVEL 2</strong>
          </h4>
          <p style={{ fontWeight: "bold" }}>OEE TOOLKIT SITE CHAMPION</p>
        </Card>
        <Card
          className="support-card"
          style={{ flex: 1, border: "1px solid #CCCCCC", textAlign: "center" }}
        >
          <h4 style={{ color: "#1E6EFE" }}>
            <strong>LEVEL 3</strong>
          </h4>
          <p style={{ fontWeight: "bold" }}>PRODUCT TEAM</p>
        </Card>
      </div>
    </div>
  );

  return (
    <div className="dflex">
      <ButtonComp
        icon={<img src={messageQuestion} />}
        onClick={() => {
          handleModal(true, 1);
        }}
        theme="blue"
        text="Support"
        style={{ marginLeft: "5px" }}
        // icon={<QuestionCircleOutlined />}
      />
      <Modal
        visible={modalOpen}
        onCancel={handleCloseModal}
        maskClosable={false}
        title={<strong style={{ fontSize: "24px" }}>Support</strong>}
        maxWidth="25%"
        footer={null}
      >
        {modalContent}
      </Modal>
    </div>
  );
};

export default Support;
